import { createMeta } from "../../../components/TapHeader";

const title = "Manage job board";
export const ManageJobBoardMeta = createMeta(title);
